export default __webpack_public_path__ + "static/media/bursaries_m.d25caf54.png";